var exports = {
  "k": "xe564cbfb--4f07b6--container",
};

module.exports = exports;
